import { render } from "./UPDATE_STORY_TIME_LEFT_REMINDER.vue?vue&type=template&id=f245452e&ts=true"
import script from "./UPDATE_STORY_TIME_LEFT_REMINDER.vue?vue&type=script&lang=ts"
export * from "./UPDATE_STORY_TIME_LEFT_REMINDER.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__